// This code is same as login-callback from @okta/react. Somehow this code wasn't working
// even after bumping the version. Maybe an issue with my system (node_modules). Will check with
// mac and change accordingly.
import { OktaAuth } from '@okta/okta-auth-js';
import { useOktaAuth } from '@okta/okta-react';
import React from 'react';
import { useHistory } from 'react-router';
import { LS_TEMPLATE_ID_KEY, RoutePaths } from 'constant/constant';
import { ActiveTab } from 'services';

export type OnAuthRequiredFunction = (
  oktaAuth: OktaAuth,
) => Promise<void> | void;
export type OnAuthResumeFunction = () => void;

interface LoginCallbackProps {
  errorComponent?: React.ComponentType<{ error: Error }>;
  onAuthResume?: OnAuthResumeFunction;
  loadingElement?: React.ReactElement;
}
const OktaError = ({ error }) => {
  if (error.name && error.message) {
    return (
      <p>
        {error.name}: {error.message}
      </p>
    );
  }

  return <p>{error.toString()}</p>;
};

export const LoginCallback: React.FC<LoginCallbackProps> = ({
  errorComponent,
  loadingElement = null,
  onAuthResume,
}) => {
  const { replace } = useHistory();
  const { oktaAuth, authState } = useOktaAuth();
  const [callbackError, setCallbackError] = React.useState(null);

  const ErrorReporter = errorComponent || OktaError;

  React.useEffect(() => {
    if (onAuthResume) {
      onAuthResume();

      return;
    }
    oktaAuth
      .handleLoginRedirect()
      .then(() => {
        const templateId = localStorage.getItem(LS_TEMPLATE_ID_KEY);

        localStorage.removeItem(LS_TEMPLATE_ID_KEY);

        if (templateId) {
          replace(
            RoutePaths.documentTemplate.replaceAll(':templateId', templateId),
          );

          return;
        }

        if (authState?.isAuthenticated) {
          const activeTab = (ActiveTab.pop() ?? '/').replace(
            window.location.origin,
            '',
          );

          replace(activeTab);
        }
      })
      .catch((e) => {
        setCallbackError(e);
      });
  }, [oktaAuth, onAuthResume, replace, authState]);

  const authError = authState?.error;
  const displayError = callbackError || authError;

  if (displayError) {
    return <ErrorReporter error={displayError} />;
  }

  return loadingElement;
};
